export { default } from './DocumentSection';
